import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { AdminGuard } from './shared';

const routes: Routes = [
    { path: 'login', loadChildren: './login/login.module#LoginModule' },
    { path: 'login/:id', loadChildren: './login/login.module#LoginModule' },
    { path: 'recover', loadChildren: './recover-password/recover-password.module#RecoverPasswordModule' },
    { path: 'not-found', loadChildren: './not-found/not-found.module#NotFoundModule' },
    { path: 'termo-de-privacidade', loadChildren: './terms-private/terms-private.module#TermsPrivateModule' },
    { path: '', loadChildren: './delivery-store/delivery-store.module#DeliveryStoreModule' },
    { path: '**', redirectTo: 'not-found' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
